import { useMemo, useState } from "react";
import { IRack } from "../../../globals/interfaces";
import VirtualTable from "../../custom/VirtualTable";
import CustomsModal from "./CustomsModal";
import useModal from "../../../customHooks/useModal";
import apiClient from "../../../apiClient";
import useUnit from "../../../customHooks/useUnit";
import useUser from "../../../customHooks/useUser";
import { getTsDate, notify } from "../../../utils";

interface Props {
    rackItems: Array<IRack>;
    updateRackData: () => void;
}

export interface UniqueAwb {
    index: number;
    s_mawb: string;
    locations: string;
    numLocations: number;
    customsHold: boolean;
}

export default function Customs ({
    rackItems,
    updateRackData
}: Props) {

    const { user } = useUser();
    const { modal, setModal } = useModal();

    const uniqueAwbs: Array<UniqueAwb> = useMemo(() => {
        const map: Record<string, {
            locationsArray: Array<string>,
            locations: string,
            customsHold: boolean
        }> = {};
        for (const item of rackItems) {
            // if (item.s_location !== 'TFEWR') continue;

            if (!map[item.s_mawb]) {
                map[item.s_mawb] = {
                    locationsArray: [],
                    locations: '',
                    customsHold: false
                }
            }
            const current = map[item.s_mawb];
            current.locationsArray.push(`${item.s_location}: ${item.i_pieces}`);
            current.locations = current.locationsArray.join(', ');

            if (!current.customsHold) {
                current.customsHold = item.b_customs_hold;
            }
        }
        const data: Array<UniqueAwb> = [];
        let index = 0;
        for (const key in map) {
            const { locations, locationsArray, customsHold } = map[key];
            data.push({
                index,
                s_mawb: key,
                locations,
                numLocations: locationsArray.length,
                customsHold
            });
            index++;
        }
        return data;
    }, [rackItems]);

    const [index, setIndex] = useState<number>();

    const handleSelectMawb = (index: number) => {
        setIndex(index);
        setModal(true);
    }

    const selectedItem = uniqueAwbs[index];

    const manageCustomsHold = async (b_customs_hold: boolean) => {
        const data: Partial<IRack> = {
            s_mawb: selectedItem.s_mawb,
            s_unit: user.s_unit,
            s_modified_by: user.s_email,
            t_modified: getTsDate(),
            b_customs_hold
        };

        const res = await apiClient.put(`/rack-customs-hold`, data);

        updateRackData();
        notify('Updated');
        setModal(false);
    }

    return (
        <div>
            <VirtualTable<UniqueAwb> 
                data={uniqueAwbs}
                mapping={[{
                    name: 'MAWB',
                    value: 's_mawb',
                    s_mawb: true
                }, {
                    name: 'Locations: pieces',
                    value: 'locations'
                }, {
                    name: 'Customs Hold',
                    value: 'customsHold',
                    boolean: true
                }]}
                handleClick={item => handleSelectMawb(item.index)}
            />
            <CustomsModal 
                modal={modal}
                setModal={setModal}
                selectedItem={selectedItem}
                manageCustomsHold={manageCustomsHold}
            />
        </div>
    );
}